import React, { useState } from "react";
import "./slideImage.css";

const slides = [
  require("../../Assets/slide1.png"),
  require("../../Assets/slide5.png"),
  require("../../Assets/slide2.png"),
  require("../../Assets/slide4.png"),
];

const CarouselPage = () => {
  const [current, setCurrent] = useState(0);
  const length = slides.length;

  const nextSlide = () => setCurrent(current === length - 1 ? 0 : current + 1);
  const prevSlide = () => setCurrent(current === 0 ? length - 1 : current - 1);

  return (
    <div className="carousel-container">
      <button className="arrow left" onClick={prevSlide}>
        &#10094;
      </button>

      {slides.map((image, index) => (
        <div
          className={index === current ? "slide active" : "slide"}
          key={index}
        >
          {index === current && (
            <img src={image} alt={`slide-${index}`} className="slide-img" />
          )}
        </div>
      ))}

      <button className="arrow right" onClick={nextSlide}>
        &#10095;
      </button>

      <div className="dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={index === current ? "dot active-dot" : "dot"}
            onClick={() => setCurrent(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default CarouselPage;
